// You can customize the template with the help of this file

//Template config options
const themeConfig = {
  app: {
    appLogoLight: require('@src/assets/images/logo/InvoHub-logo-blue.png'),
    appLogoImage: require('@src/assets/images/logo/invohub-logo-white.png'),
    faviconImage: require('@src/assets/images/logo/Group2.png'),
    faviconLight: require('@src/assets/images/logo/shape.png'),
    darkicon: require('@src/assets/images/logo/ONDARK.svg'),
    lighticon: require('@src/assets/images/logo/lightmode1.svg'),
  },
  layout: {
    isRTL: false,
    skin: 'light', // light, dark, bordered, semi-dark
    routerTransition: 'fadeIn', // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: true,
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'floating', // static , sticky , floating, hidden
      backgroundColor: 'white', // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static', // static, sticky, hidden
    },
    customizer: false,
    scrollTop: true, // Enable scroll to top button
  },
};

export default themeConfig;
